var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCommand)?_c('div',{staticClass:"linker",on:{"click":_vm.onCommand}},[_vm._t("default")],2):(_vm.linkerProps.is === 'a')?_c('a',{attrs:{"href":_vm.linkerProps.href}},[_vm._t("default")],2):_c('router-link',_vm._b({attrs:{"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{class:[isActive && 'active', isExactActive && 'exact-active'],attrs:{"href":href},on:{"click":navigate}},[_vm._t("default",null,{"isActive":isActive||isExactActive})],2)]}}],null,true)},'router-link',_vm.linkerProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }